<template>
  <v-select
    ref="currency"
    v-model="currency"
    :items="currencies"
    :label="label"
    :rules="[v => !!v || 'This field is required']"
    required
    @input="handleInput"
  ></v-select>
</template>
<script>
import { mapActions } from 'vuex';
import { formValidation } from '../../mixins/validation.mixins';

const _ = require('lodash');

export default {
  mixins: [formValidation],
  props: {
    countryCode: String,
    value: String,
    label: String,
  },
  data() {
    return {
      currency: this.value,
      currencies: [],
    };
  },
  watch: {
    async countryCode(value) {
      if (value) {
        try {
          const { data: countrySpec } = await this.retrieveCountrySpec({ countryId: value });
          this.currencies = _.chain(countrySpec.supported_bank_account_currencies).keys().map(currency => currency.toUpperCase()).value();
        } catch (e) {
          this.currencies = [];
          // eslint-disable-next-line no-console
          console.log(`Unsupported country: ${value}`);
        } finally {
          this.currency = null;
        }

      } else {
        this.currencies = [];
      }
    },
  },
  methods: {
    ...mapActions({
      retrieveCountrySpec: 'stripe/retrieveCountrySpec',
    }),
    handleInput() {
      this.$emit('input', this.currency);
    },
  },
};
</script>
